export const ACCOUNT_REVIEW = "ACCOUNT_REVIEW";
export const CHEQUE_REVIEW = "CHEQUE_REVIEW";
export const CASH_FLOW = "CASH_FLOW";
export const OVERALL_COST = "OVERALL_COST";
export const OVERALL_COST_DETAIL = "OVERALL_COST_DETAIL";
export const BALANCE_SHEET_LIST = "BALANCE_SHEET_LIST";
export const BALANCE_SHEET_DETAIL = "BALANCE_SHEET_DETAIL";
export const HASHTAG_ACTIVITY = "HASHTAG_ACTIVITY";
export const HASHTAG_DETAIL_REVIEW = "HASHTAG_DETAIL_REVIEW";
export const CONTACT_ACTIVITY = "CONTACT_ACTIVITY";
export const CONTACT_DETAIL_REVIEW = "CONTACT_DETAIL_REVIEW";